import classNames from 'classnames';
import React from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Panel = function Panel(_ref) {
  var className = _ref.className,
      children = _ref.children,
      clickable = _ref.clickable,
      type = _ref.type,
      roomy = _ref.roomy,
      bordered = _ref.bordered,
      killLastMargin = _ref.killLastMargin,
      rest = _objectWithoutPropertiesLoose(_ref, ["className", "children", "clickable", "type", "roomy", "bordered", "killLastMargin"]);

  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: classNames('panel', {
      'panel--info': type === 'info',
      'panel--tips': type === 'tips',
      'panel--new': type === 'new',
      'panel--success': type === 'success',
      'panel--warning': type === 'warning',
      'panel--error': type === 'error',
      'panel--bleed': type === 'bleed',
      'panel--bright': type === 'bright',
      'panel--neutral': type === 'neutral',
      'panel--bordered': bordered,
      'panel--is-clickable': clickable,
      'panel--is-roomy': roomy,
      'panel--kill-last-margin': killLastMargin
    }, className)
  }), children);
};

Panel.displayName = "Panel";

export default Panel;
//# sourceMappingURL=index.es.js.map
